import * as React from 'react';
import { useState } from 'react';
import { Text, Group, Line, Image} from 'react-konva';
import useImage from 'use-image';




import ImgStone from '../assets/Machines/Sten.png'
import ImgSoil from '../assets/Machines/JordSten.png'



function Stone(props){

  const [image] = useImage(ImgStone)
  const[ height, setHeight] = useState(200);

    return (
      <Line
        x={props.x}
        y={props.y}
        points={[0, 0,
          0, -height,
          props.width, -height,
          props.width, 0]}
        // fill='grey'
        stroke='black'
        strokeWidth={5}
        closed={true}
        fillPatternImage={image}
      >
      </Line>
    );
  }



function SubDirt(props) {

  const [image] = useImage(ImgSoil)
    return (
      <Line
        x={props.x}
        y={props.y}
        points={[0, 0,
          0, -props.height,
          props.width, -props.height,
          props.width, 0]}
        fillPatternImage={image}
        stroke='black'
        strokeWidth={5}
        closed={true}
      >
      </Line>
    );
  }



export class SubLayer extends React.Component {


  render() {
    const {dirtEnd, dirtStart} = this.props;    

    return (
      <Group
        x={this.props.x}
        y={this.props.y}

      >
        <SubDirt x={dirtStart} y={0} width={dirtEnd - dirtStart} height={this.props.height}/>
        <Stone x={0} y={0} width={dirtStart} />
        <Stone x={dirtEnd} y={0} width={dirtStart} />
      </Group>

    );
  }
}

class StrengBed extends React.Component {

  state = {
    sten_bredde: 150,
    sublayerHeight: 200
  };

  render() {  
    let dirtStart = this.state.sten_bredde
    let dirtEnd = this.props.width - this.state.sten_bredde
    return (
      <Group x={this.props.x} y={this.props.y}>
        <SubLayer x={0} y={0} width={this.props.width} dirtStart={dirtStart} dirtEnd={dirtEnd} height={this.state.sublayerHeight}/>
        <Line
          x={0}
          y={0}
          points={[dirtStart, -this.state.sublayerHeight,
            dirtStart + 70, -this.props.height,
            dirtEnd - 70 , -this.props.height,
            dirtEnd, -this.state.sublayerHeight]}
          fill='#a05a2c'
          stroke='black'
          strokeWidth={5}
          closed={true}
        >
        </Line>
        <Text x={0} y={100} fontSize={this.props.numberSize} text={this.props.nr} fill='black' align="center" width={this.props.width} />

      </Group>


    );
  }
}

export class Streng extends React.Component {

  
  render() {   
    return (
      <Group
        x={this.props.x}
        y={this.props.y}
      >
        {Array(this.props.nr).fill().map((e,i) => {  

          return <StrengBed  numberSize={this.props.numberSize} x={this.props.width * i} y={0} height={this.props.height} width={this.props.width} nr={i + 1} key={i.toString()}/>
        })}
      </Group>
    );
  }
}
